import wixData from 'wix-data'

var all_books_map = {}
var more_infos_cache;
var sort_history = "";
var i = 0;

async function get_all_books_from_collection(collectionName){
	var max_limit = 50;
	var num_of_books = 50;
	var all_products = []
	
	if (all_books_map[collectionName] !== undefined) {
		return all_books_map[collectionName];
	}

	for (var i = 0; i < num_of_books; i += max_limit){
		await wixData.query("Stores/Products").include("collections").limit(i + 50).skip(i).find().then(part_of_books => {
			num_of_books = part_of_books.totalCount;
			part_of_books.items.forEach(book => {
				var has_appeared = false;
				book.collections.push("null")
				book.collections.forEach(currCollection => {
					if (collectionName !== "מבצעים" && currCollection.name === "מבצעים") {
						// skip this book
						has_appeared = true;
					}
					if ((currCollection.name === collectionName || collectionName === "הכל") && !has_appeared){
						has_appeared = true;
						all_products.push(book)		
					} 
				})
			})
		})
	}
	all_books_map[collectionName] = all_products;
	try {
		$w("#loading").hide()
	} catch {}

	return all_products
}

export function updateBooksRepeater(objectId, collectionName, sort, search_value, maxBooksToShow){	
	try {
		$w("#nonBooks").hide()
	} catch {}

	get_all_books_from_collection(collectionName).then(products => {
		var books_list = [];
	
		add_main_creators(products).then(products_with_main_creators  => {
			products_with_main_creators.forEach(product => {
				var main_creator_title = "";
				var main_creator_link_creators = "#";
				if (product.main_creator !== undefined){
					main_creator_title = product.main_creator.title;
					main_creator_link_creators = product.main_creator["link-creators-title"];
				}
				var ribbon = undefined;
				if (product.ribbons[0] !== undefined) {
					ribbon = product.ribbons[0].text;
				}

				books_list.push({
					_id: String(i++),
					bookImg: product.mainMedia,
					bookImgLink: product["productPageUrl"],
					bookName: product.name,
					discountedbookPrice: product.formattedDiscountedPrice,
					originalFormattedPrice: product.formattedPrice,
					discountAmout: product.discount.value,
					bookMainCreatorName: main_creator_title,
					bookMainCreatorLink: main_creator_link_creators,
					bookRibbonText: ribbon,
					year_of_publication: product.year_of_publication,
					book_collections: product.collections,
					first_page_order: product.weight

				})	
			});
			$w(objectId).data = [];

			// search 
			if (search_value !== undefined && search_value !== "") {
				let books_list_after_search = new Set()
				var book_included_because_token = [];
				
				let splited_search_value = search_value.split(" ");
				// removing ""
				splited_search_value = splited_search_value.filter(token => token)
				books_list.forEach(book => {
					var bookName = book.bookName.replace(/[\u0591-\u05C7]/g, '');
					var bookMainCreatorName = book.bookMainCreatorName.replace(/[\u0591-\u05C7]/g, '');
					var book_collections = book.book_collections;
					var include_in_result = false;

					splited_search_value.forEach(search_token => {
						
						// Book collections:
						book_collections.forEach(book_collection => {
							if(book_collection !== "null"){
								let curr_book_collection = book_collection.name;
								if(curr_book_collection.includes(search_token)) {
									include_in_result = true;
									book_included_because_token.push(curr_book_collection)
								}	
							}
						});	

						// Book name:
						if( bookName.includes(search_token)){
							include_in_result = true;
							book_included_because_token.push(bookName)
						}

						// bookMainCreatorName:
						if (bookMainCreatorName.includes(search_token)) {
							include_in_result = true;
							book_included_because_token.push(bookMainCreatorName)
						}

						// year_of_publication:
						if (String(book.year_of_publication).includes(search_token)) {
							include_in_result = true;
							book_included_because_token.push(String(book.year_of_publication))
						}
					});

					if(include_in_result){
						books_list_after_search.add(book)
					}
				})

				console.log(book_included_because_token)
				books_list = Array.from(books_list_after_search)
			}

			// sort 
			if(sort !== undefined){
				sort_history = sort
			}
			switch(sort_history) {
				case "year":
					books_list.sort(function (a, b) {
						return a.year_of_publication - b.year_of_publication;
					});
					break;

				case "year_desc":
					books_list.sort(function (b, a) {
						return a.year_of_publication - b.year_of_publication;
					});
					break;

				case "book_name":
					books_list.sort(function (a, b) {
						return a.bookName.localeCompare(b.bookName)
					});
					break;
				case "book_name_desc":
					books_list.sort(function (b, a) {
						return a.bookName.localeCompare(b.bookName)
					});
					break;
				case "author_name":
					books_list.sort(function (a, b) {
						return a.bookMainCreatorName.localeCompare(b.bookMainCreatorName)
					});
					break;
				case "author_name_desc":
					books_list.sort(function (b, a) {
						return a.bookMainCreatorName.localeCompare(b.bookMainCreatorName)
					});
					break;
				case "first_page":
					books_list.sort(function (b, a) {
						console.log(a.bookName)
						console.log(a.first_page_order)
						return a.first_page_order - b.first_page_order;
					});
					break;
				default:
					break;
			}

			if (books_list.length === 0) {
				try {
					$w("#loading").hide()
					$w("#nonBooks").show()
				} catch {}
			}

			console.log(maxBooksToShow)
			if(maxBooksToShow && maxBooksToShow > 1) {
				books_list = books_list.filter((books, index) => index < maxBooksToShow)
			}
			$w(objectId).data = books_list;
		});
	});
}

export async function add_main_creators(productsList){
	var more_info_db = "7dblos9dbveihebleebikmu";
	
	var more_infos;
	if (more_infos_cache !== undefined) {
		console.log("get from cache")
		more_infos = more_infos_cache;
	} else {
		more_infos = await wixData.query(more_info_db).include("main_creator").limit(1000).find();
		more_infos_cache = more_infos;
	}

	productsList.forEach(product => {
		const linked_more_info = more_infos.items.find(more_info => more_info.book === product._id);
		if (linked_more_info !== undefined) {
			if(linked_more_info.main_creator === undefined) {
				console.error("main_creator of " + product.name + " is undefined");
			} else {
				product.main_creator = linked_more_info.main_creator;
				product.year_of_publication  = linked_more_info.year_of_publication;
			}
		}
	})

	return productsList;
}

export function fillBooksRepeaterInfo($item, itemData, index, id = ""){
	$item("#discountLine" + id).hide()
	$item("#bookImg" + id).src = "";
	$item("#bookImg" + id).src = itemData.bookImg;
	$item("#bookImg" + id).link = itemData.bookImgLink;
	$item("#bookName" + id).text = itemData.bookName;
	$item("#originalFormattedPrice" + id).text = fixPriceText(itemData.originalFormattedPrice);
	$item("#discountedbookPrice" + id).text = "";

	if(parseInt(itemData.discountAmout) > 0){
		$item("#discountLine" + id).show()
		$item("#discountedbookPrice" + id).text = fixPriceText(itemData.discountedbookPrice);				
	} else {
		$item("#discountedbookPrice" + id).text = fixPriceText(itemData.originalFormattedPrice);
		$item("#originalFormattedPrice" + id).text = "";
	}

	if(itemData.bookMainCreatorName !== undefined){
		$item("#bookMainCreator" + id).show();
		$item("#bookMainCreator" + id).label = itemData.bookMainCreatorName;
		$item("#bookMainCreator" + id).link = itemData.bookMainCreatorLink;
	}
	else {
		$item("#bookMainCreator" + id).hide();	
	}
	
	if(itemData.bookRibbonText !== undefined){
		$item("#bookRibbonText" + id).show();
		$item("#bookRibbon" + id).show();
		$item("#bookRibbonText" + id).text = itemData.bookRibbonText;
	}
	else{
		$item("#bookRibbonText" + id).hide();
		$item("#bookRibbon" + id).hide();
	}
	try {
		$w("#loading" + id).hide()
	} catch {}
}

export function fixPriceText(priceText) {
	priceText.trim();
	priceText = priceText.slice(0, -3);
	priceText += "₪";
	return priceText;
}